import React, { Component } from 'react';
import { Container, Accordion, Icon, Button, Modal, Header, Label } from 'semantic-ui-react';
import { PtInput, PtSelect, PtDateInput, PtTextBox } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';
import TownshipInfo from '../../../TownshipInfo';
import DocumentsGallery from './documentsgallery';
import '../../../index.css';
import 'semantic-ui-css/semantic.min.css';
import $ from 'jquery';
import config from '../../../config.json';

export default class ProjectInfo extends Component {

    constructor(props) {
        super(props);
        const { cpModel } = this.props;
        this.isDisabledTownship = false;

        let jsn = JSON.parse(sessionStorage.getItem('user'));
        this.user = jsn;
        let token = JSON.parse(sessionStorage.getItem('token'));

        if (jsn && token && jsn.isSuperAdmin) {
            let agenciesLookup = (sessionStorage.getItem('agencyLookup') == undefined ? [] : JSON.parse(sessionStorage.getItem('agencyLookup'))) || [];
            jsn = agenciesLookup.find(x => x && x.id == token.id);
            cpModel.projectInfo.isSuperAdmin = true;
            cpModel.projectInfo.superAdminEmail = this.user.email;
        } else {
            this.isDisabledTownship = true;
        }

        if (jsn !== null) {
            !cpModel.projectInfo.countyContactPersonName &&
                (cpModel.projectInfo.countyContactPersonName = jsn.name);

            !cpModel.projectInfo.countyContactPersonEmail &&
                (cpModel.projectInfo.countyContactPersonEmail = jsn.email);

            if (cpModel.projectInfo.countyContactPersonPhone)
                cpModel.projectInfo.countyContactPersonPhone = this.updatePhoneFormat(cpModel.projectInfo.countyContactPersonPhone)

            if (cpModel.projectInfo.townshipContactPersonPhone)
                cpModel.projectInfo.townshipContactPersonPhone = this.updatePhoneFormat(cpModel.projectInfo.townshipContactPersonPhone)
        }

        this.state = cpModel.projectInfo;
        this.setState({ townshipModal: false, townshipModalMessage: '' });
        // Set visibilities for lastProjectSurf subtypes
        this.changeTypeVisibilities(this.state.type);
    }

    render() {

        const { typeOptions,
            bridgeTypeOptions,
            rehabTypeOptions,
            maintTypeOptions,
            safetyTypeOptions,
            emergencyTypeOptions,
            projStatusOptions } = DropdownLib.getDropdowns().CP_ProjectInfo;

        const { lpSurfOptions } = DropdownLib.getDropdowns().CS_LastProjectSurf;
        const { ownerOptions } = DropdownLib.getDropdowns().OL_Ownership;
        const { speedOptions, applicationStatusOptions, workTypeOptions } = DropdownLib.getDropdowns().CP_ProjectInfo_Township;
        const township = TownshipInfo.getTownshipDropdowns();

        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <PtSelect label="Type" options={typeOptions} defaultVal={this.state.type} disabled={this.props.disabled}
                        onChange={this.onChangeType} name="type" />

                    <PtSelect label="Surfacing" options={lpSurfOptions} defaultVal={this.state.surfacing} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="surfacing" display={this.surfacingVis} />

                    <PtInput label="Thickness (inches)" value={this.state.thickness} disabled={this.props.disabled}
                        onChange={this.onInputChange} name="thickness" display={this.thicknessVis} />

                    <PtSelect label="Bridge Type" options={bridgeTypeOptions} defaultVal={this.state.bridgeType} disabled={this.props.disabled}
                        onChange={this.onChangeSubType} name="bridgeType" display={this.bridgeTypeVis} />

                    <PtSelect label="Rehab Type" options={rehabTypeOptions} defaultVal={this.state.rehabType} disabled={this.props.disabled}
                        onChange={this.onChangeSubType} name="rehabType" display={this.rehabTypeVis} />

                    <PtSelect label="Maintenance Type" options={maintTypeOptions} defaultVal={this.state.maintType} disabled={this.props.disabled}
                        onChange={this.onChangeSubType} name="maintType" display={this.maintTypeVis} />

                    <PtSelect label="Safety Type" options={safetyTypeOptions} defaultVal={this.state.safetyType} disabled={this.props.disabled}
                        onChange={this.onChangeSubType} name="safetyType" display={this.safetyTypeVis} />

                    <PtSelect label="Emergency Type" options={emergencyTypeOptions} defaultVal={this.state.emergencyType} disabled={this.props.disabled}
                        onChange={this.onChangeSubTypeEmergency} name="emergencyType" display={this.emergencyTypeVis} />

                    <PtTextBox label="Description" value={this.state.description} rows="2" disabled={this.props.disabled}
                        onChange={this.onInputChange} name="description" display={this.descriptionVis} />

                    {/* Township */}
                    <PtSelect label="Township (required)" options={township} defaultVal={this.state.township} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="township" display={this.townshipVis} />
                    <div style={{ marginBottom: 15, marginTop: 1, display: this.townshipVis }}>
                        <input
                            onChange={this.onCheckedChange}
                            checked={this.state.unOrganized}
                            name='unOrganized'
                            type="checkbox" /> <label style={{ paddingLeft: 3 }}>Un-Organized?</label>
                    </div>
                    <PtInput inputType="number" placeholder="0" label="Mill Levy" value={this.state.millLevy} onChange={this.onInputChangeTownship} name="millLevy" disabled={this.props.disabled} display={this.townshipVis} />
                    <PtSelect label="Type of Work" options={workTypeOptions} defaultVal={this.state.workType} disabled={this.props.disabled}
                        onChange={this.onChangeDropdown} name="workType" display={this.townshipVis} />
                    <PtTextBox label="Project Scope of Work" value={this.state.projectWorkScope} rows="1" onChange={this.onInputChangeTownship} name="projectWorkScope" disabled={this.props.disabled} display={this.townshipVis} />
                    <PtSelect label="Application Status" options={applicationStatusOptions} defaultVal={this.state.applicationStatus} disabled={this.props.disabled || this.isDisabledTownship}
                        onChange={this.onChangeDropdown} name="applicationStatus" display={this.townshipVis} />
                    <PtDateInput label="Application Status Date" value={this.state.applicationStatusDate ? this.state.applicationStatusDate.slice(0, 10) : null} disabled={this.props.disabled} display={this.townshipVis}
                        onChange={(date) => { this.onChangeDate(date, "applicationStatusDate"); }} name="applicationStatusDate" minDate={new Date(1900, 0, 1)} maxDate={new Date(2050, 5, 5)} />

                    <div>
                        <Modal
                            open={this.state.townshipModal}
                            onClose={() => { this.handleTownshipModal(false) }}
                            basic
                            size='small'>
                            <Header icon='browser' content='Project Info Township!' />

                            <Modal.Content>
                                <p>{this.state.townshipModalMessage}</p>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button color='green' onClick={() => { this.handleTownshipModal(false) }} inverted>
                                    <Icon name='checkmark' />Ok
                                </Button>
                            </Modal.Actions>
                        </Modal>
                    </div>

                    <Accordion fluid style={{ display: this.townshipVis }}>
                        <Accordion.Title className="accordion-title" style={{ marginLeft: -5 }}>
                            <Icon name='dropdown' />
                            Contact Information
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtInput label="County Contact Name" value={this.state.countyContactPersonName} onChange={this.onInputChangeTownship} name="countyContactPersonName" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="County Contact Phone Number" placeholder="(xxx)xxx-xxxx" value={this.state.countyContactPersonPhone} onChange={this.onInputChangeTownship} name="countyContactPersonPhone" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="County Contact Email Address" value={this.state.countyContactPersonEmail} onChange={this.onInputChangeTownship} name="countyContactPersonEmail" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="Township Contact Name" value={this.state.townshipContactPersonName} onChange={this.onInputChangeTownship} name="townshipContactPersonName" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="Township Contact Phone Number" placeholder="(xxx)xxx-xxxx" value={this.state.townshipContactPersonPhone} onChange={this.onInputChangeTownship} name="townshipContactPersonPhone" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="Township Contact Email Address" value={this.state.townshipContactPersonEmail} onChange={this.onInputChangeTownship} name="townshipContactPersonEmail" disabled={this.props.disabled} display={this.townshipVis} />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid style={{ display: this.townshipVis }}>
                        <Accordion.Title className="accordion-title" style={{ marginLeft: -5 }}>
                            <Icon name='dropdown' />
                            Project Details
                        </Accordion.Title>
                        <Accordion.Content>
                            <PtInput inputType="year" placeholder="1900" label="Project Proposed Year" value={this.state.projectProposedYear} onChange={this.onInputChangeTownship} name="projectProposedYear" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="Project Number" value={this.state.townshipProjectNumber} onChange={this.onInputChangeTownship} name="townshipProjectNumber" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput label="Total Project Length all Segments (miles)" value={this.state.totalProjectLength} onChange={this.onInputChangeTownship} name="totalProjectLength" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput inputType="number" placeholder="0" label="Total Project Cost Est. all Segments" value={this.state.estimatedCost} onChange={this.onInputChangeTownship} name="estimatedCost" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtInput inputType="number" placeholder="0" label="Amount of Funds Requested" value={this.state.requestedFund} onChange={this.onInputChangeTownship} name="requestedFund" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtSelect label="Proposed Surface Type" options={lpSurfOptions} defaultVal={this.state.surfaceType} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="surfaceType" display={this.townshipVis} />
                            <PtInput inputType="number" placeholder="0" label="Average Daily Traffic(AADT)" value={this.state.averageDailyTraffic} onChange={this.onInputChangeTownship} name="averageDailyTraffic" disabled={this.props.disabled} display={this.townshipVis} />
                            <PtSelect label="Speed Limit on Roadway" options={speedOptions} defaultVal={this.state.roadwaySpeedLimit} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="roadwaySpeedLimit" display={this.townshipVis} />
                            <PtSelect label="Design Speed" options={speedOptions} defaultVal={this.state.designSpeed} disabled={this.props.disabled}
                                onChange={this.onChangeDropdown} name="designSpeed" display={this.townshipVis} />
                            <PtInput label="If Bridge Involved NDDOT Bridge Number?" value={this.state.nDDOTBridgeNumber} onChange={this.onInputChangeTownship} name="nDDOTBridgeNumber" disabled={this.props.disabled} display={this.townshipVis} />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid style={{ display: this.townshipVis }}>
                        <Accordion.Title className="accordion-title" style={{ marginLeft: -5 }}>
                            <Icon name='dropdown' />
                            Federal Grant Match
                        </Accordion.Title>
                        <Accordion.Content>
                            <div style={{ marginBottom: 15, marginTop: 1, display: this.townshipVis }}>
                                <input
                                    onChange={this.onCheckedChange}
                                    checked={this.state.isInvolveFederalFund}
                                    name='isInvolveFederalFund'
                                    type="checkbox" /> <label style={{ paddingLeft: 3 }}>Does Project involve Federal Funds?</label>
                            </div>
                            <PtInput inputType="year" placeholder="1900" label="Federal Grant Award Year" value={this.state.federalGrantAwardYear} onChange={this.onInputChangeTownship} name="federalGrantAwardYear" disabled={this.props.disabled || !this.state.isInvolveFederalFund} display={this.townshipVis} />
                            <PtInput inputType="year" placeholder="1900" label="Federal Grant Construction Year" value={this.state.federalGrantConstructionYear} onChange={this.onInputChangeTownship} name="federalGrantConstructionYear" disabled={this.props.disabled || !this.state.isInvolveFederalFund} display={this.townshipVis} />
                            <PtTextBox label="Federal Grant Description" rows="2" value={this.state.federalGrantDescription} onChange={this.onInputChangeTownship} name="federalGrantDescription" disabled={this.props.disabled || !this.state.isInvolveFederalFund} display={this.townshipVis} />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid style={{ display: this.townshipVis }}>
                        <Accordion.Title className="accordion-title" style={{ marginLeft: -5 }}>
                            <Icon name='dropdown' />
                            Disaster FEMA Involvement
                        </Accordion.Title>
                        <Accordion.Content>
                            <div style={{ marginBottom: 15, marginTop: 1, display: this.townshipVis }}>
                                <input
                                    onChange={this.onCheckedChange}
                                    checked={this.state.isFEMASite}
                                    name='isFEMASite'
                                    type="checkbox" /> <label style={{ paddingLeft: 3 }}>Is this a FEMA site?</label>
                            </div>
                            <PtInput inputType="year" placeholder="1900" label="Disaster Year" value={this.state.disasterYear} onChange={this.onInputChangeTownship} name="disasterYear" disabled={this.props.disabled || !this.state.isFEMASite} display={this.townshipVis} />
                            <div style={{ marginBottom: 15, marginTop: 1, display: this.townshipVis }}>
                                <input
                                    onChange={this.onCheckedChange}
                                    checked={this.state.isSubmittedFEMA}
                                    name='isSubmittedFEMA'
                                    type="checkbox" /> <label style={{ paddingLeft: 3 }}>Submitted to FEMA?</label>
                            </div>
                            <div style={{ marginBottom: 15, marginTop: 1, display: this.townshipVis }}>
                                <input
                                    onChange={this.onCheckedChange}
                                    checked={this.state.isApprovedByFEMA}
                                    name='isApprovedByFEMA'
                                    type="checkbox" /> <label style={{ paddingLeft: 3 }}>FEMA Approve Site?</label>
                            </div>
                            <PtInput label="FEMA Approved Site Number" value={this.state.fEMAApprovedSiteNumber} onChange={this.onInputChangeTownship} name="fEMAApprovedSiteNumber" disabled={this.props.disabled || !this.state.isFEMASite} display={this.townshipVis} />
                            <PtInput label="FEMA Approved Scope of Work " value={this.state.approvedWorkScope} onChange={this.onInputChangeTownship} name="approvedWorkScope" disabled={this.props.disabled || !this.state.isFEMASite} display={this.townshipVis} />
                            <PtInput inputType="number" placeholder="0" label="FEMA Approved Cost" value={this.state.fEMAApprovedCost} onChange={this.onInputChangeTownship} name="fEMAApprovedCost" disabled={this.props.disabled || !this.state.isFEMASite} display={this.townshipVis} />
                            <PtInput label="FEMA Required Local Match" value={this.state.localMatchByFEMA} onChange={this.onInputChangeTownship} name="localMatchByFEMA" disabled={this.props.disabled || !this.state.isFEMASite} display={this.townshipVis} />
                        </Accordion.Content>
                    </Accordion>

                    <Accordion fluid style={{ display: this.townshipVis }}>
                        <Accordion.Title className="accordion-title" style={{ marginLeft: -5 }}>
                            <Icon name='dropdown' />
                            Document Uploads
                        </Accordion.Title>
                        <Accordion.Content>
                            {this.townshipVis == 'block' &&
                                <DocumentsGallery
                                    triggerNeedSave={this.props.triggerNeedSave}
                                    disabled={this.props.disabled}
                                    loggedIn={this.props.loggedin}
                                    showLoadingSpinner={this.props.showSpinner}
                                    constructionPlanning={this.props.cpModel}
                                    documentsModel={this.state.documents} />
                            }
                        </Accordion.Content>
                    </Accordion>

                    <div style={{ display: this.townshipVis == 'none' ? 'block' : 'none' }}>
                        <PtInput label="Project Number" value={this.state.projectNumber} onChange={this.onInputChange} name="projectNumber" disabled={this.props.disabled} />
                        <PtInput inputType="year" placeholder="1900" label="Planned Year" value={this.state.plannedYear} onChange={this.onInputChange} name="plannedYear" disabled={this.props.disabled} />

                        <PtSelect label="Project Status" options={projStatusOptions} defaultVal={this.state.projectStatus} disabled={this.props.disabled}
                            onChange={this.onChangeDropdown} name="projectStatus" />

                        <PtDateInput label="Project Status Date" value={this.state.projectStatusDate} disabled={this.props.disabled}
                            onChange={(date) => { this.onChangeDate(date, "projectStatusDate"); }} name="projectStatusDate" maxDate={new Date(2050, 5, 5)} />

                        <PtDateInput label="Bid Opening Date" value={this.state.bidOpeningDate} disabled={this.props.disabled}
                            onChange={(date) => { this.onChangeDate(date, "bidOpeningDate"); }} name="bidOpeningDate" maxDate={new Date(2050, 5, 5)} />

                        <PtInput inputType="number" placeholder="0" label="Estimated Total Cost" value={this.state.estimatedTotalCost} onChange={this.onInputChange} name="estimatedTotalCost" disabled={this.props.disabled} />
                        <PtInput inputType="number" placeholder="0" label="Final Total Cost" value={this.state.finalTotalCost} onChange={this.onInputChange} name="finalTotalCost" disabled={this.props.disabled} />

                        <PtInput inputType="number" placeholder="0" label="Total Project Length (miles)" value={this.state.length} onChange={this.onInputChange} name="length" disabled={this.props.disabled} />

                        <PtSelect label="Owner" options={ownerOptions} defaultVal={this.state.owner} disabled={this.props.disabled}
                            onChange={this.onChangeDropdown} name="owner" />
                    </div>

                </ScrollArea>

                <div style={{ display: this.townshipVis, marginTop: 8 }}>
                    <Button style={{ float: 'left' }} size='mini' color="green" disabled={(this.user && this.user.isSuperAdmin) ||
                        (this.state.applicationStatus && this.state.applicationStatus!=0 && this.state.applicationStatus != 4)} onClick={() => this.submitTownship()} >Submit</Button>

                    <Label color='blue' style={{ marginLeft: 10, marginTop: 2 }} basic size='small'>
                        {this.state.submittedDate ? this.getDate(this.state.submittedDate) : 'Not Submitted'}
                    </Label>
                </div>


            </Container>
        );
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });

        if (name == 'township') {
            let township = TownshipInfo.getTownshipDropdowns();
            let item = township.find(x => x.key == value);
            item && this.setState({ 'unOrganized': item.unOrganized ? true : false });
        }
    }

    onChangeType = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
        // Change visibility of conditional fields
        // eslint-disable-next-line
        this.changeTypeVisibilities(parseInt(value));
    }

    onChangeSubType = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });

        // Change visibility of description field
        this.descriptionVis = 'none';
        // eslint-disable-next-line
        if (parseInt(value) === 5)
            this.descriptionVis = 'block';
    }

    onChangeSubTypeEmergency = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });

        // Change visibility of description field
        this.descriptionVis = 'none';
        // eslint-disable-next-line
        if (parseInt(value) === 6)
            this.descriptionVis = 'block';
    }

    changeTypeVisibilities(value) {

        // set all to not visible
        this.surfacingVis = 'none';
        this.thicknessVis = 'none';
        this.bridgeTypeVis = 'none';
        this.rehabTypeVis = 'none';
        this.maintTypeVis = 'none';
        this.safetyTypeVis = 'none';
        this.emergencyTypeVis = 'none';
        this.descriptionVis = 'none';
        this.townshipVis = 'none';

        // set chosen type to visible
        switch (value) {
            case 1:
            case 2:
            case 3:
            case 4:
                this.surfacingVis = 'block';
                this.thicknessVis = 'block';
                break;
            case 5:
                this.bridgeTypeVis = 'block';
                if (this.state.bridgeType === 5)
                    this.descriptionVis = 'block';
                break;
            case 6:
                this.rehabTypeVis = 'block';
                if (this.state.rehabType === 5)
                    this.descriptionVis = 'block';
                break;
            case 7:
                this.maintTypeVis = 'block';
                if (this.state.maintType === 5)
                    this.descriptionVis = 'block';
                break;
            case 8:
                this.safetyTypeVis = 'block';
                if (this.state.safetyType === 5)
                    this.descriptionVis = 'block';
                break;
            case 9:
                this.emergencyTypeVis = 'block';
                if (this.state.emergencyType === 6)
                    this.descriptionVis = 'block';
                break;
            case 10:
                this.descriptionVis = 'block';
                break;
            case 11:
                this.townshipVis = 'block';
                break;
            default:
                console.log("changeTypeVisibilities error. Default case reached");
                break;
        }
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.props.triggerNeedSave();
        if (name === 'projectNumber')
            this.setState({ [name]: value });
        // eslint-disable-next-line
        else this.setState({ [name]: value === '' ? null : parseFloat(value) });
    }

    onInputChangeTownship = (e) => {
        let { name, value } = e.target;
        this.props.triggerNeedSave();

        if (name == 'townshipContactPersonPhone' || name == 'countyContactPersonPhone') {
            value = this.updatePhoneFormat(value)
        }

        this.setState({ [name]: value });
    }

    updatePhoneFormat(value) {
        value = value.replace(/\D/g, '');
        if (value.length > 1) value = value.replace(/.{0}/, '$&(')
        if (value.length > 4) value = value.replace(/.{4}/, '$&)')
        if (value.length > 8) value = value.replace(/.{8}/, '$&-')
        if (value.length > 13) value = value.slice(0, 13);

        return value;
    }

    onCheckedChange = (e) => {
        const { target } = e;

        const { name } = target;
        this.props.triggerNeedSave();
        this.setState({ [name]: !this.state[name] });
    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        if (date instanceof Date && !isNaN(date)) {
            this.setState({ [name]: date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : null });
        }
    }

    submitTownship() {
        const savebutton = document.getElementById("savebutton");
        let values = this.state;

        if (savebutton || !values['townshipId']) {
            this.setState({ townshipModal: true, townshipModalMessage: 'Please try to submit after saving the informations or reselect the points!' });
            return;
        }

        let requiredItems = [
            { key: 'millLevy', value: 'Mill Levy', isDropdown: false },
            { key: 'workType', value: 'Type of Work', isDropdown: true },
            { key: 'projectWorkScope', value: 'Project Scope of Work', isDropdown: false },
            { key: 'countyContactPersonName', value: 'County Contact Name', isDropdown: false },
            { key: 'countyContactPersonPhone', value: 'County Contact Phone Number', isDropdown: false },
            { key: 'countyContactPersonEmail', value: 'County Contact Email Address', isDropdown: false },
            { key: 'townshipContactPersonName', value: 'Township Contact Name', isDropdown: false },
            { key: 'townshipContactPersonPhone', value: 'Township Contact Phone Number', isDropdown: false },
            { key: 'townshipContactPersonEmail', value: 'Township Contact Email Address', isDropdown: false },
            { key: 'projectProposedYear', value: 'Project Proposed Year', isDropdown: false },
            { key: 'townshipProjectNumber', value: 'Project Number', isDropdown: false },
            { key: 'totalProjectLength', value: 'Total Project Length', isDropdown: false },
            { key: 'estimatedCost', value: 'Total Project Cost Est.', isDropdown: false },
            { key: 'requestedFund', value: 'Amount of Funds Requested', isDropdown: false },
            { key: 'surfaceType', value: 'Proposed Surface Type', isDropdown: true },
            { key: 'averageDailyTraffic', value: 'Average Daily Traffic', isDropdown: false },
            { key: 'roadwaySpeedLimit', value: 'Speed Limit on Roadway', isDropdown: true },
            { key: 'designSpeed', value: 'Design Speed', isDropdown: true },
            { key: 'federalGrantAwardYear', value: 'Federal Grant Award Year', isDropdown: false, federalGrantMatch: true },
            { key: 'federalGrantConstructionYear', value: 'Federal Grant Construction Year', isDropdown: false, federalGrantMatch: true },
            { key: 'disasterYear', value: 'Disaster Year', isDropdown: false, fEMASite: true },
            { key: 'fEMAApprovedSiteNumber', value: 'FEMA Approved Site Number', isDropdown: false, fEMASite: true },
            { key: 'approvedWorkScope', value: 'FEMA Approved Scope of Work', isDropdown: false, fEMASite: true },
            { key: 'fEMAApprovedCost', value: 'FEMA Approved Cost', isDropdown: false, fEMASite: true },
            { key: 'localMatchByFEMA', value: 'FEMA Required Local Match', isDropdown: false, fEMASite: true }
        ];

        let invalidItems = [];

        Object.keys(values).forEach(x => {
            let foundItem = requiredItems.find(y => y.key == x);
            if (foundItem) {
                if (foundItem.isDropdown && !values[x] || values[x] == 0) {
                    invalidItems.push(foundItem.value);
                } else if (values['isInvolveFederalFund'] && foundItem.federalGrantMatch && !values[x]) {
                    invalidItems.push(foundItem.value);
                } else if (values['isFEMASite'] && foundItem.fEMASite && !values[x]) {
                    invalidItems.push(foundItem.value);
                } else if (!foundItem.isDropdown && !foundItem.federalGrantMatch && !foundItem.fEMASite && !values[x]) {
                    invalidItems.push(foundItem.value);
                }
            }

        });

        if (invalidItems.length > 0) {
            let message = 'Please fill up these fields: ' + invalidItems.join(', ') + '!';
            this.setState({ townshipModal: true, townshipModalMessage: message });
            return;
        }

        let finalData = {
            townshipId: this.state.townshipId,
            submittedDate: new Date()
        };

        console.log(finalData)
        $.ajax({
            type: 'POST',
            url: `${config.server}\\submittownship`,
            contentType: 'application/json',
            data: JSON.stringify(finalData),

            success: (data) => {
                console.log('Success data ', data)
                if (data['message'] === "OK") {
                    this.setState({ applicationStatus: 1, submittedDate: finalData.submittedDate });
                }
            },
        });
    }

    handleTownshipModal(value) {
        this.setState({ townshipModal: value });
    }

    getDate(dateValue) {
        const newDate = new Date(dateValue)
        const showDate = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000)
        return `${showDate.getFullYear()}-${('0' + (showDate.getMonth() + 1)).slice(-2)}-${('0' + showDate.getDate()).slice(-2)}`
    }

    componentDidUpdate() {
        console.log(this.state);
        this.props.cpModel.projectInfo = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/cons-planning/project-info.js